import ZotokLogo from './svgs/ZoTok_Logo.svg?url';
import InfoIcon from './svgs/infoIcon.svg?url';
import RightArrow from './svgs/RightArrow.svg?url';
// import RightArrowComponent from './svgs/RightArrow.svg?react';
import RightArrowComponent from './svgs/RightArrow.svg?component';
import RightArrowIcon from './svgs/right_arrow.svg?url';
import CompanyNameIcon from './svgs/CompanyIcon.svg?url';
import GstinIcon from './svgs/GST_doc.svg?url';
import CalendarIcon from './svgs/calendar.svg?url';
import TradeIcon from './svgs/TradeIcon.svg?url';
import Info from './svgs/Info.svg?url';
import Location from './svgs/Location.svg?url';
import ArrowRight from './svgs/arrow_right.svg?url';
import ArrowLeft from './svgs/arrow_left.svg?url';
// import ArrowLeftComponent from './svgs/arrow_left.svg?react';
import ArrowLeftComponent from './svgs/arrow_left.svg?component';
import SuccessTick from './svgs/Success_Tick.svg?url';
import PhoneIcon from './svgs/Phone.svg?url';
import UserIcon from './svgs/user.svg?url';
import EmailIcon from './svgs/email.svg?url';
import ErrorIcon from './svgs/Error.svg?url';
import BrandManufacturerIcon from './svgs/brandManufacturerIcon.svg?url';
import DistributionIcon from './svgs/Distribution_Icon.svg?url';
import RetailerIcon from './svgs/StoreIcon.svg?url';
import RadioUncheckIcon from './svgs/RadioUncheckIcon.svg?url';
import RadioCheckedIcon from './svgs/RadioCheckedIcon.svg?url';
import RegistredImage from './svgs/registredImage.svg';
import CheckIcon from './svgs/Check.svg?url';
import Loader from './pngs/loader.png';
import LoaderGif from './gifs/loading-animation.gif';
import ErrorWhite from './svgs/error-white.svg?url';
import CloseWhite from './svgs/close-white.svg?url';
import InfoGreyFillIcon from './svgs/info-grey-fill.svg?url';
// import InfoGreyFillIconComponent from './svgs/info-grey-fill.svg?react';
import InfoGreyFillIconComponent from './svgs/info-grey-fill.svg?component';
// import CompanyNameIconComponent from './svgs/CompanyIcon.svg?react';
import CompanyNameIconComponent from './svgs/CompanyIcon.svg?component';
// import CalendarIconComponent from './svgs/calendar.svg?react';
import CalendarIconComponent from './svgs/calendar.svg?component';
// import GstinIconComponent from './svgs/GST_doc.svg?react';
import GstinIconComponent from './svgs/GST_doc.svg?component';
// import TradeIconComponent from './svgs/TradeIcon.svg?react';
import TradeIconComponent from './svgs/TradeIcon.svg?component';
// import LocationIconComponent from './svgs/Location.svg?react';
import LocationIconComponent from './svgs/Location.svg?component';
// import UserIconComponent from './svgs/user.svg?react';
import UserIconComponent from './svgs/user.svg?component';
// import EmailIconComponent from './svgs/email.svg?react';
import EmailIconComponent from './svgs/email.svg?component';
// import PhoneIconComponent from './svgs/Phone.svg?react';
import PhoneIconComponent from './svgs/Phone.svg?component';
import CompletedIconComp from './svgs/Success_Tick.svg?url';
import InputInfo from './svgs/input_info.svg?url';
import InputInfoError from './svgs/infput_info_error.svg?url';
import SelectArrowUp from './svgs/select_arrow_up.svg?url';
import SelectArrowDown from './svgs/select_arrow_down.svg?url';
import InfoNew from './svgs/info_new.svg?url';
import InfoError from './svgs/info-error.svg?url';
import InfoBlueIcon from './svgs/info-blue.svg?url';
import InfoGreenIcon from './svgs/info-green.svg?url';
import AddGradient from './svgs/add-gradient.svg?url';
import RightArrowBlack from './svgs/right-arrow-black.svg?url';
import LeftArrowBlue from './svgs/left-arrow-blue.svg?url';
import Document from './svgs/document.svg?url';
import MoreIcon from './svgs/more-icon.svg?url';
import RefreshIcon from './svgs/refresh-icon.svg?url';
import ZotokIcon from './svgs/zotok-icon.svg?url';
import MetaIcon from './svgs/meta-icon.svg?url';
import WebsiteEmail from './svgs/website-email.svg?url';
import LegalDocuments from './svgs/legal-documents.svg?url';
import Announce from './pngs/announce.png';
import BuildKnowledge from './pngs/build-knowledge.png';
import Factory from './pngs/factory.png';
import TestAndDeploy from './pngs/test-and-deploy.png';
import Whatsapp from './pngs/whatsapp.png';
import HomeIcon from './svgs/home-icon.svg?url';
import UploadKnowledge from './pngs/upload-knowledge.png';
import AgentTraining from './pngs/agent-training.png';
import AnnounceYourBusiness from './pngs/announce-your-business.png';
import WabaSetupIcon from './pngs/waba-setup-icon.png';
import HomeWhiteIcon from './svgs/home-white-icon.svg?url';
import EducationalRobot from './gifs/educational-robot.gif';
import ExcitedRobot from './gifs/excited-robot.gif';
import WhatsappBig from './pngs/whatsapp-big.png';
import DeployAgent from './gifs/deploy-agent.gif';
import LogoutIcon from './svgs/logout.svg?url';
import DeleteIcon from './svgs/delete-icon.svg?url';
import EyeIcon from './svgs/eye-icon.svg?url';
import TickGreenIcon from './svgs/tick-green-icon.svg?url';
import NoUploadedFiles from './pngs/no-uploaded-files.png';
import WarningIcon from './pngs/warning-icon.png';
import CopyIcon from './svgs/copy.svg?url';
import ShareIcon from './svgs/share.svg?url';
import NotAccessible from './svgs/no-accessible.svg?url';
import SignupIcon1 from './pngs/signup-icon-1.png';
import SignupIcon2 from './pngs/signup-icon-2.png';
import SignupIcon3 from './pngs/signup-icon-3.png';
import Splash1 from './pngs/splash-1.png';
import Splash2 from './pngs/splash-2.png';
import Splash3 from './pngs/splash-3.png';
import Splash4 from './pngs/splash-4.png';
import Splash5 from './pngs/splash-5.png';
import FacebookIcon from './svgs/Facebook.svg?url';
import Link_URL from './svgs/link_URL.svg?url';
import BotAdvantage1 from './pngs/bot-advantage-1.png';
import BotAdvantage2 from './pngs/bot-advantage-2.png';
import BotAdvantage3 from './pngs/bot-advantage-3.png';
import VerticalDivider from './svgs/vertical-divider.svg?url';
import HorizontalDivider from './svgs/horizontal-divider.svg?url';
import ProfileIcon from './svgs/profile-icon.svg?url';
// import VideoCallIcon from './svgs/video-call-icon.svg?react';
import VideoCallIcon from './svgs/video-call-icon.svg?component';
// import AudioCallIcon from './svgs/audio-call-icon.svg?react';
import AudioCallIcon from './svgs/audio-call-icon.svg?component';
import InfoFillIcon from './svgs/info-fill-icon.svg';
// import InfoFillIconComponent from './svgs/info-fill-icon.svg?react';
import InfoFillIconComponent from './svgs/info-fill-icon.svg?component';
import InfoFillWhiteIcon from './svgs/info-fill-white-icon.svg';
// import InfoFillWhiteIconComponent from './svgs/info-fill-white-icon.svg?react';
import InfoFillWhiteIconComponent from './svgs/info-fill-white-icon.svg?component';
import AddGreenIcon from './svgs/add-green-icon.svg?url';
import StickerGreenIcon from './svgs/sticker-green-icon.svg?url';
import WhatsappSendIcon from './svgs/whatsapp-send-icon.svg?url';
import MonitorImage from './pngs/monitor-image.png';
import SendOutlinedIcon from './svgs/send-outlined-icon.svg?url';
import SendOutlinedIconComponent from './svgs/send-outlined-icon.svg?component';
import MobileWhatsappBackground from './pngs/mobile-whatsapp-background.png';
import BackIcon from './svgs/back-icon.svg?url';
import AddBlueIcon from './svgs/add-blue.svg?url';
import WelcomeModalImage from './pngs/welcome-modal-image.png';
import CampaignImage1 from './pngs/campaign-image-1.png';
import CampaignImage2 from './pngs/campaign-image-2.png';
import CampaignImage3 from './pngs/campaign-image-3.png';
import CampaignImage4 from './pngs/campaign-image-4.png';
import CampaignImage5 from './pngs/campaign-image-5.png';
import CopyBlueIcon from './svgs/copy-blue.svg?url';
import ShareBlueIcon from './svgs/share-blue.svg?url';
import PlayIcon from './svgs/play-icon.svg?url';
import NewTabIcon from './svgs/new-tab-icon.svg?url';
import RightArrowBlue from './svgs/right-arrow-blue.svg?url';
import SuccessTickDark from './svgs/success-tick-green.svg?url';
import ArrowLeftBlue from './svgs/arrow-left-blue.svg?url';
import ErrorRobotImage from './pngs/error-robot-image.png';
import EyeGreenIcon from './svgs/eye-green-icon.svg?url';
import WorkingAwesome from './gifs/working-awesome.gif';
import WhatsappIcon from './svgs/whatsapp-icon.svg';
import MenuTooltipImage from './pngs/menu-tooltip-image.png';
import SearchIcon from './svgs/search-icon.svg';
import GlobeIconComponent from './svgs/globe-icon.svg?component';

export const SVGS = {
  ZotokLogo: ZotokLogo,
  InfoIcon: InfoIcon,
  RightArrow: RightArrow,
  RightArrowComponent: RightArrowComponent,
  RightArrowIcon: RightArrowIcon,
  CompanyNameIcon: CompanyNameIcon,
  CompanyNameIconComponent: CompanyNameIconComponent,
  GstinIcon: GstinIcon,
  GstinIconComponent: GstinIconComponent,
  CalendarIcon: CalendarIcon,
  CalendarIconComponent: CalendarIconComponent,
  TradeIcon: TradeIcon,
  TradeIconComponent: TradeIconComponent,
  Info: Info,
  Location: Location,
  LocationIconComponent: LocationIconComponent,
  ArrowRight: ArrowRight,
  ArrowLeft: ArrowLeft,
  ArrowLeftComponent: ArrowLeftComponent,
  SuccessTick: SuccessTick,
  PhoneIcon: PhoneIcon,
  PhoneIconComponent: PhoneIconComponent,
  UserIcon: UserIcon,
  CompletedIconComp,
  UserIconComponent: UserIconComponent,
  EmailIcon: EmailIcon,
  EmailIconComponent: EmailIconComponent,
  ErrorIcon: ErrorIcon,
  BrandManufacturerIcon: BrandManufacturerIcon,
  DistributionIcon: DistributionIcon,
  RetailerIcon: RetailerIcon,
  RadioUncheckIcon: RadioUncheckIcon,
  RadioCheckedIcon: RadioCheckedIcon,
  RegistredImage: RegistredImage,
  FacebookIcon,
  Link_URL,
  CheckIcon: CheckIcon,
  ErrorWhite,
  CloseWhite,
  InfoGreyFillIcon,
  InfoGreyFillIconComponent,
  InputInfo,
  InputInfoError,
  SelectArrowUp,
  SelectArrowDown,
  InfoNew,
  HomeIcon,
  AddGradient,
  RightArrowBlack,
  LeftArrowBlue,
  Document,
  MoreIcon,
  RefreshIcon,
  ZotokIcon,
  MetaIcon,
  WebsiteEmail,
  LegalDocuments,
  InfoError,
  InfoBlueIcon,
  InfoGreenIcon,
  HomeWhiteIcon,
  LogoutIcon,
  DeleteIcon,
  EyeIcon,
  TickGreenIcon,
  CopyIcon,
  ShareIcon,
  NotAccessible,
  VerticalDivider,
  HorizontalDivider,
  ProfileIcon,
  AudioCallIcon,
  VideoCallIcon,
  InfoFillIcon,
  InfoFillIconComponent,
  InfoFillWhiteIcon,
  InfoFillWhiteIconComponent,
  AddGreenIcon,
  StickerGreenIcon,
  WhatsappSendIcon,
  SendOutlinedIcon,
  SendOutlinedIconComponent,
  BackIcon,
  AddBlueIcon,
  CopyBlueIcon,
  ShareBlueIcon,
  PlayIcon,
  NewTabIcon,
  RightArrowBlue,
  SuccessTickDark,
  ArrowLeftBlue,
  EyeGreenIcon,
  WhatsappIcon,
  SearchIcon,
  GlobeIconComponent,
};

export const PNGS = {
  Loader,
  Announce,
  BuildKnowledge,
  TestAndDeploy,
  Whatsapp,
  Factory,
  UploadKnowledge,
  AgentTraining,
  SuccessTick,
  AnnounceYourBusiness,
  WabaSetupIcon,
  WhatsappBig,
  NoUploadedFiles,
  WarningIcon,
  SignupIcon1,
  SignupIcon2,
  SignupIcon3,
  Splash1,
  Splash2,
  Splash3,
  Splash4,
  Splash5,
  BotAdvantage1,
  BotAdvantage2,
  BotAdvantage3,
  MonitorImage,
  MobileWhatsappBackground,
  WelcomeModalImage,
  CampaignImage1,
  CampaignImage2,
  CampaignImage3,
  CampaignImage4,
  CampaignImage5,
  ErrorRobotImage,
  MenuTooltipImage,
};
export const GIFS = {
  DeployAgent,
  EducationalRobot,
  ExcitedRobot,
  WorkingAwesome,
  LoaderGif,
};
